import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Dropdown } from 'react-bootstrap';
import TextSearch from '@/shared/components/input/TextSearch';
import intlShape from '@/shared/utils/intlShape';
import enumCache from '@/shared/services/EnumCacheService';
import messages from './trainingMessages';
import EnumSelectV2 from '@/shared/components/input/EnumSelectV2';
import CompanySelector from '@/shared/components/input/CompanySelector';
import EmployeeTagMultiSelect from '@/modules/hrm/EmployeeTagMultiSelect';
import TeamMultiSelect from '@/shared/components/input/multiselect/TeamMultiSelect';
import EmployeeRoleSelector from '@/shared/components/input/EmployeeRoleSelector';
import isEqual from 'lodash.isequal';
import { FaUndo } from 'react-icons/fa';

export const defaultTrainingEmployeeModalFilters = {
  searchValue: '',
  employeeType: null,
  companyId: null,
  withEmployeeLabels: [],
  role: null,
  customRoleId: null,
  teams: [],
};

class TrainingEmployeeModalFilters extends Component {
  static propTypes = {
    onFilterChange: PropTypes.func.isRequired,
    filters: PropTypes.shape({
      searchValue: PropTypes.string,
      employeeType: PropTypes.number,
      companyId: PropTypes.string,
      withEmployeeLabels: PropTypes.arrayOf(PropTypes.string),
      role: PropTypes.string,
      customRoleId: PropTypes.string,
    }),
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    filters: defaultTrainingEmployeeModalFilters,
  };

  componentDidMount() {
    const { intl, filters } = this.props;
  }

  hasActiveFilters = () => {
    const { filters } = this.props;

    return (
      filters.searchValue !== defaultTrainingEmployeeModalFilters.searchValue ||
      filters.employeeType !== defaultTrainingEmployeeModalFilters.employeeType ||
      filters.companyId !== defaultTrainingEmployeeModalFilters.companyId ||
      !isEqual(
        filters.withEmployeeLabels,
        defaultTrainingEmployeeModalFilters.withEmployeeLabels,
      ) ||
      filters.role !== defaultTrainingEmployeeModalFilters.role ||
      filters.customRoleId !== defaultTrainingEmployeeModalFilters.customRoleId ||
      !isEqual(filters.teams, defaultTrainingEmployeeModalFilters.teams)
    );
  };

  resetFilters = () => {
    this.filterChanged({ ...defaultTrainingEmployeeModalFilters });
  };

  filterChanged = filter => {
    const { filters, onFilterChange } = this.props;
    const newFilters = { ...filters, ...filter };
    if (filters !== newFilters) onFilterChange(newFilters);
  };

  render() {
    const { filters, onFilterChange, intl, addSelectedEmployeesButton } = this.props;

    return (
      <div className="training-employee-modal-filters">
        <div className="row">
          <div className="col-lg-4 col-md-6 margin5B">
            <div className="form-group">
              <TextSearch
                value={filters.searchValue}
                className="form-control"
                placeholder={intl.formatMessage(messages.SearchEmployees)}
                onChange={value => this.filterChanged({ searchValue: value })}
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-6 margin5B">
            <div className="form-group">
              <EnumSelectV2
                enumType="employeeType"
                value={filters.employeeType ?? ''}
                allowNull
                placeholder={intl.formatMessage(messages.EmployeeType)}
                onChange={value => this.filterChanged({ employeeType: value })}
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-6 margin5B">
            <div className="form-group">
              <CompanySelector
                onChange={companyId => this.filterChanged({ companyId: companyId || null })}
                value={filters.companyId}
                placeholder={intl.formatMessage(messages.OwnCompany)}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6 margin5B">
            <div className="form-group">
              <EmployeeTagMultiSelect
                value={filters.withEmployeeLabels}
                onChange={withEmployeeLabels => this.filterChanged({ withEmployeeLabels })}
                placeholder={intl.formatMessage(messages.WithEmployeeTags)}
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-6 margin5B">
            <div className="form-group">
              <TeamMultiSelect
                selection={filters.teams}
                onChange={value => this.filterChanged({ teams: value })}
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-6 margin5B">
            <div className="form-group">
              <EmployeeRoleSelector
                onChange={selectedRole => {
                  if (selectedRole) {
                    this.filterChanged({
                      role: selectedRole.role,
                      customRoleId: selectedRole.customRoleId || null,
                    });
                  } else {
                    this.filterChanged({ role: null, customRoleId: null });
                  }
                }}
                value={{
                  role: filters.role || null,
                  customRoleId: filters.customRoleId || null,
                }}
                placeholder={intl.formatMessage(messages.AllRoles)}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6 margin5B">
            <div className="form-group"></div>
            {this.hasActiveFilters() && (
              <button
                type="button"
                className="btn btn-default btn-reset"
                onClick={this.resetFilters}
              >
                <FaUndo className="react-icon" />
                &nbsp;
                <FormattedMessage {...messages.ResetFilters} />
              </button>
            )}
          </div>
          <div className="col-lg-4 col-md-6 margin5B"></div>
          <div className="col-lg-4 col-md-6 margin5B text-right">
            {addSelectedEmployeesButton && (
              <Button
                className="btn btn-xs btn-inverse"
                disabled={addSelectedEmployeesButton.disabled}
                onClick={addSelectedEmployeesButton.onClick}
                style={{ whiteSpace: 'nowrap' }}
              >
                <span className="margin5R">{addSelectedEmployeesButton.icon}</span>
                {addSelectedEmployeesButton.label}
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(TrainingEmployeeModalFilters);
